<template>
    <div class="flex flex-col md:flex-row h-fit w-full md:w-8/12 px-4 md:px-0 mx-auto">
        <div class="w-full md:w-6/12 h-full md:sticky top-10 mb-10 md:mb-0">
            <img class="h-full w-auto" :src="`${require('@/assets/img/resumo-executivo/logo.png')}`" alt="" />
        </div>
        <div class="w-full 1080p:w-8/12 md:w-6/12 p-0 md:pl-8 h-fit">
            <h1 class="font-serif font-semibold text-5xl text-black mb-2 leading-none -mt-2">Resumo executivo</h1>
            <div class="mb-6"><button class="font-semibold">See English version</button></div>
            <ul class="flex flex-col justify-between gap-2 mb-10">
                <li>
                    <router-link class="execSum_index" to="/resumo-executivo/prefacio">
                        <small>Apresentação</small>
                        <h2>FAPESP 60 anos, por Carlos Vogt</h2>
                    </router-link>
                </li>
                <li>
                    <router-link class="execSum_index" to="/apresentacao">
                        <small>PREFÁCIO</small>
                        <h2 class="w-full 1080p:w-1/2">FAPESP, um patrimônio da população paulista, por Marco Antonio Zago</h2>
                    </router-link>
                </li>
                <li>
                    <router-link
                        class="execSum_index"
                        :to="{
                            name: 'SingleExecSumView',
                            params: {
                                slug: 'seis-decadas-de-realizacoes',
                                idx: '1',
                                componentName: 'Texto1PT',
                                fa: 1,
                            },
                        }"
                    >
                        <small>Fascículo 1</small>
                        <h2>Seis décadas de realizações</h2>
                    </router-link>
                </li>
                <li>
                    <router-link
                        class="execSum_index"
                        :to="{
                            name: 'SingleExecSumView',
                            params: {
                                slug: 'dna-da-ciencia-paulista',
                                idx: '2',
                                componentName: 'Texto2PT',
                                fa: 1,
                            },
                        }"
                    >
                        <small>Fascículo 2</small>
                        <h2>DNA da ciência paulista</h2>
                    </router-link>
                </li>
                <li>
                    <router-link
                        class="execSum_index"
                        :to="{
                            name: 'SingleExecSumView',
                            params: {
                                slug: 'pioneirismo-digital',
                                componentName: 'Texto3PT',
                                idx: '3',
                                fa: 1,
                            },
                        }"
                    >
                        <small>Fascículo 3</small>
                        <h2>Pioneirismo digital</h2>
                    </router-link>
                </li>
                <li>
                    <router-link
                        class="execSum_index"
                        :to="{
                            name: 'SingleExecSumView',
                            params: {
                                slug: 'grandes-projetos-grandes-resultados',
                                componentName: 'Texto4PT',
                                idx: '4',
                                fa: 1,
                            },
                        }"
                    >
                        <small>Fascículo 4</small>
                        <h2>Grandes projetos, grandes resultados</h2>
                    </router-link>
                </li>
                <li>
                    <router-link
                        class="execSum_index"
                        :to="{
                            name: 'SingleExecSumView',
                            params: {
                                slug: 'politicas-publicas-baseadas-em-evidencias',
                                componentName: 'Texto5PT',
                                idx: '5',
                                fa: 1,
                            },
                        }"
                    >
                        <small>Fascículo 5</small>
                        <h2>Políticas públicas baseadas em evidências</h2>
                    </router-link>
                </li>
                <li>
                    <router-link
                        class="execSum_index"
                        :to="{
                            name: 'SingleExecSumView',
                            params: {
                                slug: 'contribuicao-social-cultural-e-artistica',
                                componentName: 'Texto6PT',
                                idx: '6',
                                fa: 1,
                            },
                        }"
                    >
                        <small>Fascículo 6</small>
                        <h2>Contribuição social, cultural e artística</h2>
                    </router-link>
                </li>
                <li>
                    <router-link
                        class="execSum_index"
                        :to="{
                            name: 'SingleExecSumView',
                            params: {
                                slug: 'inovacao-e-empreendedorismo',
                                componentName: 'Texto6PT',
                                idx: '7',
                                fa: 1,
                            },
                        }"
                    >
                        <small>Fascículo 7</small>
                        <h2>Inovação e empreendedorismo</h2>
                    </router-link>
                </li>
                <li>
                    <router-link
                        class="execSum_index"
                        :to="{
                            name: 'SingleExecSumView',
                            params: {
                                slug: 'diversidade-e-inclusao',
                                componentName: 'Texto7PT',
                                idx: '8',
                                fa: 1,
                            },
                        }"
                    >
                        <small>Fascículo 8</small>
                        <h2>Diversidade e inclusão</h2>
                    </router-link>
                </li>
                <li>
                    <router-link
                        class="execSum_index"
                        :to="{
                            name: 'SingleExecSumView',
                            params: {
                                slug: 'licoes-da-pandemia',
                                componentName: 'Texto6PT',
                                idx: '9',
                                fa: 1,
                            },
                        }"
                    >
                        <small>Fascículo 9</small>
                        <h2>Lições da pandemia</h2>
                    </router-link>
                </li>
                <li>
                    <router-link
                        class="execSum_index"
                        :to="{
                            name: 'SingleExecSumView',
                            params: {
                                slug: 'de-olho-no-futuro',
                                componentName: 'Texto6PT',
                                idx: '10',
                                fa: 1,
                            },
                        }"
                    >
                        <small>Fascículo 10</small>
                        <h2>De olho no futuro</h2>
                    </router-link>
                </li>
                <li>
                    <router-link
                        class="execSum_index"
                        :to="{
                            name: 'ExecSumView',
                            // params: {
                            //     slug: 'indicadores',
                            //     componentName: 'IndicatorsAll',
                            // },
                        }"
                    >
                        <small>Resumo executivo</small>
                        <h2>Indicadores FAPESP 60 anos</h2>
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {}
    },
}
</script>

<style lang="postcss" scoped>
.execSum_index {
    @apply text-xl font-serif font-semibold;
}
small {
    @apply font-light font-sans uppercase block leading-none;
}
h2 {
    @apply block mt-0 text-xl;
}
li {
    @apply mb-3;
}
</style>
